import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { Action } from 'redux';
import {
  CreateCollaboratorSuccess,
  CreateCollaborator,
} from '../action-creators';
import { CREATE_COLLABORATOR_SUCCESS } from '../actions';

export const createCreditForFeaturedArtistEpic = (
  action$: Observable<Action>
) =>
  action$.pipe(
    ofType<Action, CreateCollaboratorSuccess>(CREATE_COLLABORATOR_SUCCESS),
    filter(
      (action) =>
        action.collaborator.type === 'COLLABORATOR' &&
        action.collaborator.role === 'featuring'
    ),
    map((action) => {
      const { id, created_at, updated_at, ...newCollaborator } =
        action.collaborator;
      return new CreateCollaborator({
        ...newCollaborator,
        role: '',
        type: 'CONTRIBUTOR',
      });
    })
  );
